var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_32944_28283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0691 6.10738C15.4954 5.89503 14.6794 4.9522 14.4047 4.56148C14.1049 4.13678 13.9717 3.71208 14.03 3.39781C12.5729 4.09431 9.18408 4.35762 7.91016 4.33214V3.48275C9.76692 3.50823 13.1973 3.07504 13.9217 2.48895C14.0883 2.35305 14.3214 2.34456 14.5046 2.45498C14.8043 2.64184 14.9375 3.09202 14.8459 3.56769C14.8376 3.831 15.5537 5.04563 17.1773 5.26648L17.0691 6.10738Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4229 13.6158C9.74179 13.6158 7.76846 11.0421 7.39378 7.05848C7.15232 4.52728 7.56863 2.65011 8.61774 1.46096C9.48368 0.492649 10.7659 0 12.4229 0C14.0798 0 15.4203 0.501143 16.2862 1.48644C17.3354 2.6756 17.7267 4.55276 17.4602 7.05848C17.0273 11.1016 15.0956 13.6158 12.4312 13.6158H12.4229ZM12.4229 0.849396C10.9991 0.849396 9.92497 1.24861 9.23389 2.03006C8.34298 3.03234 8.0016 4.68866 8.22641 6.97354C8.55946 10.49 10.2164 12.7664 12.4312 12.7664C14.646 12.7664 16.2529 10.541 16.6359 6.96504C16.8774 4.71415 16.5527 3.05782 15.6701 2.05554C14.9707 1.25711 13.8799 0.849396 12.4312 0.849396H12.4229Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4231 26.0005C12.165 26.0005 11.9485 25.8221 11.8902 25.5673L9.15918 13.7522V11.8071H9.99181V13.7012L12.4314 24.1998L14.9959 13.6163L14.921 11.7137L15.7536 11.6797L15.8285 13.7012L12.9476 25.5673C12.8894 25.8136 12.6729 25.992 12.4148 25.992L12.4231 26.0005Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.4984 17.9493C11.2245 17.9493 10.0588 17.1169 9.65918 15.9362L10.4502 15.6644C10.7333 16.5138 11.5825 17.1084 12.5068 17.1084C13.431 17.1084 14.2636 16.4714 14.5384 15.5625L15.3294 15.8173C14.9464 17.0744 13.7807 17.9578 12.4984 17.9578V17.9493Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.32677 17.4118L7.49414 17.3609L7.66067 14.4135C7.66067 14.303 7.71895 14.1926 7.80221 14.1162L9.30094 12.7656L9.85048 13.4027L8.48497 14.6343L8.32677 17.4118Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.5199 17.4133L16.3617 14.6358L15.1377 13.5316L15.6872 12.8945L17.0361 14.1092C17.1193 14.1856 17.1693 14.2875 17.1776 14.4065L17.3442 17.3539L16.5115 17.4048L16.5199 17.4133Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1.33263 25.5594H0.5V19.3927C0.666525 17.9743 1.54911 16.8106 2.80638 16.3094L7.91871 14.2539L8.22678 15.0438L3.11445 17.0994C2.14028 17.4901 1.46585 18.3905 1.33263 19.4522V25.5679V25.5594Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.3962 25.5738H23.5636V19.3817C23.4387 18.3794 22.7559 17.4791 21.7901 17.0799L16.6777 15.0243L16.9858 14.2344L22.0981 16.2899C23.3554 16.7911 24.238 17.9547 24.3962 19.3307V25.5653V25.5738Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.51265 19.0611C5.23789 16.2326 7.57757 14.6187 7.67748 14.5508L8.13543 15.2558C8.05217 15.3152 6.11215 16.6658 6.33695 18.9761L5.50433 19.0611H5.51265Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.02773 25.4569H6.60309V24.6075H7.02773C7.22756 24.6075 7.41074 24.514 7.54396 24.3611C7.67718 24.2083 7.72714 24.0044 7.68551 23.8005L7.07769 20.4794C7.02773 19.8763 6.56146 19.4431 6.02025 19.4431C5.47905 19.4431 5.00445 19.8763 4.96282 20.4369L4.355 23.809C4.32169 24.0044 4.37165 24.2083 4.49655 24.3611C4.62144 24.514 4.80462 24.6075 5.00445 24.6075H5.47072V25.4569H5.00445C4.56316 25.4569 4.13852 25.253 3.85542 24.9048C3.57233 24.5565 3.45576 24.0978 3.53902 23.6561L4.14684 20.3265C4.22178 19.3752 5.04608 18.5938 6.02858 18.5938C7.01108 18.5938 7.83538 19.3752 7.91864 20.369L8.51814 23.6477C8.6014 24.0978 8.48483 24.5565 8.19341 24.9048C7.91032 25.253 7.48568 25.4569 7.04439 25.4569H7.02773Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M19.0426 21.9553H18.2099V18.6002C18.2099 17.9037 18.0267 17.2157 17.6854 16.6211L16.7861 15.0582L17.5022 14.625L18.4014 16.1879C18.8177 16.9184 19.0426 17.7508 19.0426 18.6002V21.9553Z",
    fill: "#FF8C69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M18.6259 25.2443C17.5768 25.2443 16.7275 24.378 16.7275 23.3077C16.7275 22.2375 17.5768 21.3711 18.6259 21.3711C19.675 21.3711 20.5243 22.2375 20.5243 23.3077C20.5243 24.378 19.675 25.2443 18.6259 25.2443ZM18.6259 22.2205C18.0348 22.2205 17.5602 22.7131 17.5602 23.3077C17.5602 23.9023 18.0348 24.3949 18.6259 24.3949C19.2171 24.3949 19.6917 23.9108 19.6917 23.3077C19.6917 22.7046 19.2171 22.2205 18.6259 22.2205Z",
    fill: "#FF8C69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32944_28283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.36588596589157adf42e2c1e3aa88773.svg";
export { ForwardRef as ReactComponent };